var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#1A1F71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5955 45.188C62.2507 56.6091 51.89 64.787 40.4689 63.4422C29.0478 62.0975 23.4297 49.7726 23.4297 49.7726M23.4297 49.7726L32.7817 50.8738M23.4297 49.7726L22.2116 60.1178M22.2147 40.3156C23.5595 28.8945 33.8374 20.7069 45.3413 22.0614C59.1418 23.6863 64.6772 36.0015 64.6772 36.0015M64.6772 36.0015L65.8953 25.6563M64.6772 36.0015L55.4906 34.9198",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.42cbede9010a7cec8b0291c4f581dd32.svg";
export { ForwardRef as ReactComponent };